export default __webpack_public_path__ + "static/media/metamask.268e99ed.svg";